/**
 * Report endpoints — see api/types/reports.ts for the full confirmation notes on
 * `Report/Reservations`'s request/response shape (curl-confirmed against the local
 * backend, including real populated rows for Air/Transfer), and on `Entry/Find` (moved
 * here from api/endpoints/air.ts once confirmed it's tagged `Report` in swagger, not
 * Air-specific).
 */
import { apiPost } from '../client';
import type {
  EntryFindRequest,
  EntryFindResponse,
  FindCurrentAccountRequest,
  FindCurrentAccountResponse,
  ReservationReportRequest,
  ReservationReportResponse,
} from '../types/reports';

export function getReservationReports(
  body: ReservationReportRequest
): Promise<ReservationReportResponse> {
  return apiPost<ReservationReportRequest, ReservationReportResponse>(
    'Report/Reservations',
    body
  );
}

export function entryFind(body: EntryFindRequest): Promise<EntryFindResponse> {
  return apiPost<EntryFindRequest, EntryFindResponse>('Entry/Find', body);
}

export function findCurrentAccount(
  body: FindCurrentAccountRequest
): Promise<FindCurrentAccountResponse> {
  return apiPost<FindCurrentAccountRequest, FindCurrentAccountResponse>(
    'Report/FindCurrentAccount',
    body
  );
}
